import React, { useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import BanListTable from '../Components/BanListTable';
import BanListAdd from '../Components/BanListAdd';

const BanListPage = () => {
  const [banList, setBanList] = useState([]);

  const handleAdd = (newItem) => {
    setBanList(prevList => [...prevList, newItem]);
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
      Список заблокированных сайтов
      </Typography>
      <Box mb={2}>
        <BanListAdd onAdd={handleAdd} />
      </Box>
      <BanListTable
        banList={banList}
        setBanList={setBanList}
      />
    </Container>
  );
};

export default BanListPage;
